import { Switch, Label } from '@valiant/ui-shared'
import { useGetMaintenanceModeQuery, useSetMaintenanceModeMutation } from '@/generated/graphql'
import { toast } from 'sonner'

export function MaintenanceModeToggle() {
  const [{ data, fetching }, refetch] = useGetMaintenanceModeQuery()
  const [{ fetching: updating }, setMaintenanceMode] = useSetMaintenanceModeMutation()

  const isEnabled = data?.getMaintenanceMode ?? false

  const handleToggle = async (checked: boolean) => {
    const result = await setMaintenanceMode({ enabled: checked })
    if (result.error) {
      toast.error('Failed to update maintenance mode')
    } else {
      toast.success(checked ? 'Maintenance mode enabled' : 'Maintenance mode disabled')
      refetch({ requestPolicy: 'network-only' })
    }
  }

  return (
    <div className="flex items-center gap-3 rounded-lg border border-orange-200 bg-orange-50 px-4 py-3 dark:border-orange-900 dark:bg-orange-950">
      <div className="flex flex-col gap-1">
        <Label
          htmlFor="maintenance-mode"
          className="text-sm font-medium text-orange-800 dark:text-orange-200"
        >
          Maintenance Mode
        </Label>
      </div>
      <Switch
        id="maintenance-mode"
        checked={isEnabled}
        onCheckedChange={handleToggle}
        disabled={fetching || updating}
        className="data-[state=checked]:bg-orange-500"
      />
    </div>
  )
}
